import '../scss/main.scss';

import Flickity from 'flickity';
import 'flickity/dist/flickity.css';

import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import TweenMax from 'gsap/TweenMax';
import TimelineMax from 'gsap/TimelineMax';

window.addEventListener('DOMContentLoaded', () => {
	let blockCarouselContainers = document.querySelectorAll('.block-type-carousel');

	if (blockCarouselContainers.length < 1) {
		return;
	}

	blockCarouselContainers = [].slice.call(blockCarouselContainers);

	blockCarouselContainers.forEach(container => {
		new Flickity(container, {
			contain: true,
			pageDots: true,
			prevNextButtons: false,
			autoPlay: true,
			wrapAround: true,
			setGallerySize: false,
			cellSelector: '.block-type-carousel .image-wrapper',
			cellAlign: 'left'
		});
	});
});

window.addEventListener('DOMContentLoaded', () => {
	// Animaties
	let tooSmall = false;
	const maxWidth = 900;

	if (window.innerWidth < maxWidth) {
		tooSmall = true;
	}

	function initScrollMagic() {
		const controller = new ScrollMagic.Controller();

		let blockRows = document.querySelectorAll('.content-wrapper.module-blocks .blocks-wrapper.blocks-count-2.is-parallax');
		blockRows = [].slice.call(blockRows);

		blockRows.forEach((blockRow, index) => {

			const blockImage = blockRow.querySelector('.block-type-image');
			const blockCarousel = blockRow.querySelector('.block-type-carousel');
			const blockVideo = blockRow.querySelector('.block-type-video');
			const textBlock = blockRow.querySelector('.block-type-text');

			const parallaxTl = new TimelineMax();

			if (blockImage) {
				parallaxTl.to(blockImage, 1, { y: '-15%', ease:Power0.easeNone }, 'imageAnim');
			}

			if (blockCarousel) {
				parallaxTl.to(blockCarousel, 1, { y: '-15%', ease:Power0.easeNone }, 'imageAnim');
			}

			if (blockVideo) {
				parallaxTl.to(blockVideo, 1, { y: '-20%', ease:Power0.easeNone }, 'imageAnim');
			}

			if (textBlock) {
				parallaxTl.to(textBlock, 1, { y: '10%', ease:Power0.easeNone }, 'imageAnim');
			}

			new ScrollMagic.Scene({
				triggerElement: blockRow,
				triggerHook: 1,
				offset: 50,
				duration: '100%'
			})
				.setTween(parallaxTl)
				.addTo(controller);
		});

		blockRows.forEach((blockRow, index) => {
			const blockImage = blockRow.querySelector('.block-type-image') ? blockRow.querySelector('.block-type-image') : document.createElement('div');
			const blockCarousel = blockRow.querySelector('.block-type-carousel') ? blockRow.querySelector('.block-type-carousel') : document.createElement('div');
			const blockVideo = blockRow.querySelector('.block-type-video') ? blockRow.querySelector('.block-type-video') : document.createElement('div');
			const textBlock = blockRow.querySelector('.block-type-text') ? blockRow.querySelector('.block-type-text') : document.createElement('div');
			const textBlockTitle = blockRow.querySelector('.block-type-text h1') ? blockRow.querySelector('.block-type-text h1') : document.createElement('div');
			const textBlockText = blockRow.querySelectorAll('.block-type-text p') ? blockRow.querySelectorAll('.block-type-text p') : document.createElement('div');

			const animateIn = new TimelineMax();

			animateIn
				.from(blockImage, .5, { x: '-=50px', autoAlpha: 0 }, 'animImageIn')
				.from(blockCarousel, .5, { x: '-=50px', autoAlpha: 0 }, 'animImageIn')
				.from(blockVideo, .5, { x: '-=50px', autoAlpha: 0 }, 'animImageIn')
				.from(textBlock, .5, { autoAlpha: 0 }, 'animTextBlockIn')
				.from(textBlockTitle, .5, { y: '-=25px', autoAlpha: 0 }, 'animTextBlockIn+=0.15')
				.from(textBlockText, .5, { y: '-=25px', autoAlpha: 0 }, 'animTextBlockIn+=0.25');

			new ScrollMagic.Scene({
				triggerElement: blockRow,
				triggerHook: 'onEnter',
				offset: '150',
				reverse: false
			}).setTween(animateIn).addTo(controller);
		});
	}

	if (!tooSmall) {
		initScrollMagic();
	}
});